import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageNWSL7 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Sophia Wilson Re-Signs ",
            author: "footballgirl",
             date: "January, 2026",
            image: "images/nwsl/7a.jpg",
            content: `<h2>Sophia Wilson Re-Signs with Portland Thorns for 2026 Season</h2>

    <h2>Landmark Commitment and Historic Contract</h2>
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
    <p>In a landmark moment for the National Women's Soccer League (NWSL), Portland Thorns forward <strong>Sophia Wilson</strong> (formerly known as Sophia Smith) has committed to returning to the club for the 2026 season by exercising her player option. The announcement, made on December 17, 2025, ensures the USWNT superstar stays in the Rose City after missing the entire 2025 campaign on maternity leave.</p>

    <p>The option, part of the multi-year extension she signed in March 2024, is reportedly worth a record <span class="highlight">$1 million</span> annually—the first seven-figure contract year in NWSL history. This milestone underscores the league's growing investment in elite talent and Wilson's status as one of its brightest stars. The 2024 deal originally made her the highest-paid player in the league on an annual basis, and this activation solidifies her place with Portland through at least the end of 2026.</p>

    <h2>Career Highlights and Thorns Legacy</h2>
    <p>Wilson, the No. 1 overall pick in the 2020 NWSL Draft out of Stanford, has been a cornerstone of the Thorns since her debut. She won the NWSL MVP award in 2022 as the youngest recipient in league history and led the team in goals for four straight seasons (2021–2024). Her dynamic play, speed, and finishing have made her a fan favorite at Providence Park, where she has expressed deep affection for the supporters and the environment.</p>

    <h2>Personal Milestones and Time Away</h2>
    <p>After her last appearance in November 2024, Wilson married Arizona Cardinals wide receiver Michael Wilson and announced her pregnancy in early 2025. She gave birth to their daughter, Gianna ("Gigi"), in September 2025. While she sat out the full season to focus on motherhood, Wilson has been preparing for her comeback. In early 2026 interviews, she shared that she's feeling strong and aims to be ready for Portland's season opener on March 13 against the Washington Spirit. She's also eyeing a return to the USWNT for events like the SheBelieves Cup.</p>

    <h2>Decision to Stay and Broader Impact</h2>
    <p>Wilson has spoken about weighing her options but ultimately choosing to stay with the only professional club she's known. <em>"There's no place like it,"</em> she said. <em>"That is the place to play and I'm excited to be back in it."</em> Her decision provides stability for the Thorns' attack as they rebuild and chase titles, while highlighting progress in player rights, compensation, and work-life balance in women's soccer.</p>

    <p>This commitment is seen as a major win for the franchise and the NWSL, especially as the league navigates new compensation mechanisms to retain top players amid rising global interest in women's football.</p>      
   <p> 索菲娅·威尔逊与波特兰荆棘队续约2026赛季  </p>  <h1>索菲娅·威尔逊与波特兰荆棘队续约2026赛季</h1>

    <h2>里程碑式承诺与历史性合同</h2>
    <p>在美国女子职业足球联赛（NWSL）的一个里程碑时刻，波特兰荆棘队前锋<strong>索菲娅·威尔逊</strong>（原名索菲娅·史密斯）通过行使球员选项，承诺将在2026赛季重返球队。该消息于2025年12月17日公布，这位美国女足超级巨星在因产假缺席整个2025赛季后，将继续留在玫瑰城。</p>

    <p>该选项源于她在2024年3月签署的多年度续约合同，据报道价值创纪录的<strong>100万美元</strong>年薪——这是NWSL历史上首个七位数合同年。这一里程碑凸显了联赛对顶级人才日益增长的投资，以及威尔逊作为联赛最耀眼球星的地位。2024年的合同最初让她成为联赛年薪最高的球员，此次激活选项巩固了她至少到2026赛季结束留在波特兰的地位。</p>

    <h2>职业生涯亮点与荆棘队传奇</h2>
    <p>威尔逊在2020年NWSL选秀中以状元身份从斯坦福大学加盟，自出道以来一直是荆棘队的中流砥柱。她在2022年赢得NWSL MVP奖，成为联赛历史上最年轻获奖者，并在2021–2024连续四个赛季领跑球队进球榜。她充满活力、速度与终结能力的比赛风格，让她在普罗维登斯公园成为球迷的最爱，她也多次表达了对支持者和球场环境的深厚感情。</p>

    <h2>个人里程碑与暂别赛场</h2>
    <p>在2024年11月最后一次出场后，威尔逊与亚利桑那红雀队外接手迈克尔·威尔逊结婚，并于2025年初宣布怀孕。她于2025年9月诞下女儿吉安娜（昵称“Gigi”）。虽然为了专注于母亲角色而缺席了整个赛季，但威尔逊一直在为复出做准备。在2026年初的采访中，她表示自己感觉状态良好，并目标是准备好参加波特兰队3月13日对阵华盛顿精神队的赛季揭幕战。她还计划重返美国女足，参加如SheBelieves Cup等赛事。</p>

    <h2>留队决定及其更广泛影响</h2>
    <p>威尔逊表示她权衡过各种选择，但最终选择留在她唯一效力的职业俱乐部。“这里无可替代，”她说。“这是最适合踢球的地方，我很兴奋能重返其中。”她的决定为荆棘队的锋线提供了稳定性，帮助球队在重建中追逐冠军，同时也凸显了女子足球在球员权利、薪酬和工作生活平衡方面的进步。</p>

    <p>这一承诺被视为对球队和NWSL的重大胜利，尤其是在联赛通过新的薪酬机制留住顶级球员、应对全球女子足球兴趣日益增长的背景下。</p> `,
                      tags: ["NWSL", "portland thorns", "Sophia smith", "footballgirl",],
navIndices: { prev: 'nwsl-6', next: 'nwsl-8' }
        });
    }

    init() {
        console.log('ArticlePageNWSL7 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to NWSL
            `;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'nwsl' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_nwsl.png';
            leagueLogo.alt = 'NWSL';
        }
    }
}